"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CookieBot.default;
  }
});

var _CookieBot = _interopRequireDefault(require("./CookieBot"));

module.exports = exports.default;